import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { FormArray, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { AgentsService } from '../agents.service';
import { IAgent } from '../agents.interface';
import { ExternalRequestService } from '../../../../shared/components/external-request/external-request.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-agents-modal',
  templateUrl: './agents-modal.component.html',
  styleUrls: ['./agents-modal.component.css']
})
export class AgentsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showEdit: boolean = true;
  loading: boolean = false;
  saving: boolean = false;
  agent!: IAgent
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  action!: string;

  constructor(
    private _AgentsService: AgentsService,
    private _ExternalRequestService: ExternalRequestService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  async ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    if (this.agent._id) {
      this.action = "Modificar"
      await this.getAgent();
    } else {
      this.action = "Crear"
      await this.buildForm();
    }
    console.log(this.readOnly)
  }

  async getAgent() {
    this.loading = true;
    await this._AgentsService.getAgent(this.agent._id || '').subscribe((agent) => {
      console.log(agent)
      this.agent = agent;
      this.buildForm();
    });
  }

  get f() { return this.form.controls; }
  async buildForm() {
    this.form = this.fb.group({
      name: [this.agent.name, [Validators.required]],
      phone: [this.agent.phone],
      email: [this.agent.email],
    })
    this.loading = false;
  }

  setEditable(value: boolean = false) {
    this.readOnly = value;
  }

  async onSubmit() {
    this.submitted = true;
    let data: IAgent = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    data.company = this._AuthService.companyId();

    if (this.agent._id) {
      data._id = this.agent?._id;
      this._AgentsService.updateAgent(data).subscribe({
        next: (agent) => {
          this.dialog.close(agent);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    } else {
      this._AgentsService.createAgent(data).subscribe({
        next: (agent) => {
          this.dialog.close(agent);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    }
  }

  cancelSubmit() {
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getAgent();
  }

}
